import React from 'react';
import PropTypes from 'prop-types';
import {
  LinearProgress as Progress,
  linearProgressClasses,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { BaseComponent } from '../../prop-types/component';

const StyledLinearProgress = styled(Progress)(() => ({
  height: 18,
  borderRadius: 25,
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    background: 'linear-gradient(90deg, #0D9488 0%, #5EEAD4 100%)',
  },
}));

const clampProgress = (value) => {
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return 0;
  }
  return Math.min(100, Math.max(0, value));
};

export const LinearProgress = ({ name, value, className, sx }) => {
  return (
    <StyledLinearProgress
      variant="determinate"
      value={clampProgress(value)}
      aria-label={name}
      className={className}
      sx={{
        backgroundColor: 'rgba(255,255,255,0.2)',
        border: 'none',
        ...sx,
      }}
    />
  );
};

LinearProgress.propTypes = {
  ...BaseComponent,
  value: PropTypes.number,
  name: PropTypes.string,
};
